<template>
    <div>
        <!-- name -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="content.name" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        
        <!-- alias -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Alias</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="content.alias" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- language -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Language</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select v-model="content.language">
                                <option v-for="lang in languages" :key="lang">{{lang}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- title -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Title</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="content.title" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- type -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Type</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select v-model="content.type">
                                <option>text</option>
                                <option>html</option>
                                <option>wysiwyg</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- data -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Data</label>
            </div>
            <div class="field-body">
            </div>
        </div>
        <string-text ref="string-text" v-if="content.type == 'text'" :data="content.data" />
        <string-html ref="string-html" v-if="content.type == 'html'" :data="content.data" />
        <string-wysiwyg ref="string-wysiwyg" v-if="content.type == 'wysiwyg'" :data="content.data" />

        <!-- save -->
        <div class="field is-grouped" style="margin-top: 1rem;">
            <div class="control">
                <button class="button" @click="cancel()">Cancel</button>
            </div>
            <div class="control">
                <button class="button is-primary" @click="save(false)">Save</button>
            </div>
            <div class="control">
                <button class="button is-primary" @click="save(true)">Save and exit</button>
            </div>
        </div>
    </div>
</template>

<script>
import MediumEditor from 'medium-editor'

import state from '../../../../state'
import contentService from '../../../../services/content.service';

import StringText from './string-text.vue'
import StringHtml from './string-html.vue'
import StringWysiwyg from './string-wysiwyg.vue'

export default {
    name: 'content-string-edit',
    components: { StringText, StringHtml, StringWysiwyg },
    props: {
        content: {
            type: Object,
            required: true
        },
        backRoute: {
            type: Object,
            required: true
        }
    },
    computed: {
        result() {
            return (
                (this.$refs['string-text'] && this.$refs['string-text'].$data.result) ||
                (this.$refs['string-html'] && this.$refs['string-html'].$data.result) ||
                (this.$refs['string-wysiwyg'] && this.$refs['string-wysiwyg'].$data.result) || ''
            );
        },
        languages() {
            return state.languages.get();
        }
    },
    methods: {
        cancel() {
            this.$router.push(this.backRoute)
        },
        async save(exit) {
            this.content.data = this.result;
            await contentService.updateString(this.content);
            if(exit) this.$router.push(this.backRoute)
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/string/content-string-edit.vue